export type RecommendedActionTemplate = {
	description: string;
	disabled: boolean;
	id: number;
	label: string;
	name: string;
	type: RecommendedActionTemplateType;
};

export enum RecommendedActionTemplateType {
	Monitor = 'Monitor',
	DataDictionary = 'DataDicationary'
}
